import { useQuery } from 'react-query';
import api from 'api';
import { useDraftEmployeeId } from './useDraftEmployeeId';
import { GET_DRAFT_EMPLOYEE } from '../data';
import { PayrollGetDraftEmployeeResponse } from 'api/gql-utils/employeeOnboardingGql/types';
import { useToast } from '@razorpay/blade/components';
import { parseGraphqlErrorFromExtensions } from 'utils/Api';
import { AppError } from 'utils/AppError';
import { getPeoplePage } from 'utils/links';
import useFeature from 'hooks/useFeature';

export const useDraftEmployeeData = ({
  onSuccess,
}: {
  onSuccess?: (data: PayrollGetDraftEmployeeResponse['payrollGetDraftEmployee']['data']) => void;
} = {}) => {
  const { draftEmployeeId } = useDraftEmployeeId();
  const { isEmployeeOnboardingEnabled } = useFeature('employeeOnboarding');
  const toast = useToast();

  const queryResponse = useQuery({
    queryKey: [GET_DRAFT_EMPLOYEE, draftEmployeeId],
    queryFn: () => api.employeeOnboardingGql.queries.getDraftEmployee(draftEmployeeId),
    enabled: !!draftEmployeeId && isEmployeeOnboardingEnabled,
    select: (response) => {
      return response.payrollGetDraftEmployee.data;
    },
    onSuccess: (response) => {
      onSuccess?.(response);
    },
    onError: (error: typeof AppError) => {
      toast.show({
        content: parseGraphqlErrorFromExtensions(error),
        color: 'negative',
      });
      window.location.href = getPeoplePage(isEmployeeOnboardingEnabled);
    },
    refetchOnMount: true,
  });

  return queryResponse;
};
